const translation = {
  tags: {
    education: 'Giáo dục',
    medical: 'Y',
    business: 'Kinh doanh',
    weather: 'Thời tiết',
    finance: 'Tài chính',
    productivity: 'Năng suất',
    design: 'Thiết kế',
    videos: 'Video',
    utilities: 'Tiện ích',
    social: 'Xã hội',
    search: 'Tìm kiếm',
    news: 'Tin tức',
    image: 'Ảnh',
    agent: 'Người đại lý',
    other: 'Khác',
    travel: 'Du lịch',
    entertainment: 'Giải trí',
  },
  searchTags: 'Thẻ tìm kiếm',
  allTags: 'Tất cả thẻ',
}

export default translation
